"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var saveToDisk_1 = require("../../helpers/saveToDisk");
var OrderCardController = /** @class */ (function () {
    function OrderCardController(OrdersModel, FlashService, OrderDetailsService, PoliciesModel, UserService, UsersModel, VueStoreFactory) {
        this.OrdersModel = OrdersModel;
        this.FlashService = FlashService;
        this.OrderDetailsService = OrderDetailsService;
        this.PoliciesModel = PoliciesModel;
        this.UsersModel = UsersModel;
        this.VueStoreFactory = VueStoreFactory;
        this.loading = true;
        this.submitting = false;
        this.modalShown = false;
        this.billingConfig = {
            gateway: '',
            gateway_config: {},
            policyMeta: {}
        }; //used for order details modal
        this.clearPaymentForm = false;
        this.currentUser = UserService.getCurrentUser();
        this.showOrderDetails = this.showOrderDetails.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitPayment = this.submitPayment.bind(this);
        this.voidPayment = this.voidPayment.bind(this);
        this.voidOrder = this.voidOrder.bind(this);
        this.sendOrder = this.sendOrder.bind(this);
        this.printOrder = this.printOrder.bind(this);
        this.refundOrder = this.refundOrder.bind(this);
    }
    OrderCardController.prototype.centsToDollars = function (cents) {
        return (0, Teller_1.inDollars)(cents);
    };
    OrderCardController.prototype.showOrderDetails = function (order) {
        var _this = this;
        this.OrdersModel.getDetails({ id: order.id }).then(function (response) {
            _this.order = _this.OrderDetailsService.setupOrderDetails(response, order);
            var billing = _this.VueStoreFactory.state.policies.policies.find(function (policy) { return policy.name === 'billing'; });
            var drives = _this.VueStoreFactory.state.policies.policies.find(function (policy) { return policy.name === 'drives'; });
            var resp = {
                policy: {
                    id: billing.id,
                    policymeta: __spreadArray(__spreadArray([], drives.policymeta, true), billing.policymeta, true)
                }
            };
            _this.billingConfig = _this.OrderDetailsService.configureBilling(resp);
            if (_this.billingConfig.gateway === 'paypal') {
                // console.log('Configuring PayPal Gateway');
                // this.configurePaypal(order, this.billingConfig);
            }
            _this.clearPaymentForm = false;
            _this.modalShown = true;
            _this.loading = false;
        });
    };
    OrderCardController.prototype.closeModal = function () {
        this.modalShown = false;
        this.clearPaymentForm = true;
    };
    OrderCardController.prototype.submitPayment = function (data) {
        var _this = this;
        var payment = data.payment;
        this.submitting = true;
        this.OrderDetailsService.setPayment(payment);
        this.OrderDetailsService.submitPayment().then(function (response) {
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.payments.push(response.payment);
            _this.submitting = false;
            _this.order.paid = response.order.paid;
            _this.order.notes = response.order.notes;
            _this.clearPaymentForm = true;
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    OrderCardController.prototype.voidPayment = function (data) {
        var _this = this;
        var payment_id = data.payment_id, index = data.index;
        this.submitting = true;
        this.UsersModel.voidPayment(this.order.student.id, payment_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.payments.splice(index, 1, response.payment);
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    OrderCardController.prototype.voidOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.voidOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.status = 'VOID';
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    OrderCardController.prototype.refundOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.refundOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order = response.order;
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    OrderCardController.prototype.sendOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.sendOrder(data.order_id, { 'recipient': data.receipt_email }).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    OrderCardController.prototype.printOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.printOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            (0, saveToDisk_1.saveToDisk)(response.url);
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    return OrderCardController;
}());
OrderCardController.$inject = ['OrdersModel', 'FlashService', 'OrderDetailsService', 'PoliciesModel', 'UserService', 'UsersModel', 'VueStoreFactory'];
exports.default = OrderCardController;
